// extracted by mini-css-extract-plugin
export var displayNone = "_pd-6";
export var imgContainer = "_pd-2";
export var overflowHidden = "_pd-3";
export var productInfoCardButtonContainer = "_pd-5";
export var productTitleText = "_pd-4";
export var rightArrow = "_pd-1";
export var rightArrowContainer = "_pd-0";